import React from "react";
import PageIntro from "../../components/PageIntro";
import { introContent } from "./aboutContent";

/**
 * Opening statement of the page: the H1 and the introduction, straight from
 * the approved About Us document. Presentation lives in the shared PageIntro
 * panel, the same one the Home and Services pages open with.
 */
const AboutIntro = () => (
  <PageIntro
    id="about-intro-heading"
    title={introContent.title}
    subtitle={introContent.subtitle}
    paragraphs={introContent.paragraphs}
    images={[
      "/assets/intro/certification-compliance.webp",
      "/assets/intro/global-standards.webp",
      "/assets/intro/business-growth.webp",
    ]}
  />
);

export default AboutIntro;
